import apiClient from '@/utils/apiClient';

const UPDATE_EMBEDDABLE_API_PATH = '/api/embeddables';
const GET_EMBEDDABLE_API_PATH = '/api/embeddables';

export const updateEmbeddableConfig = async (
	payload: any,
): Promise<{ message: string; embeddableVoiceId: string }> => {
	const { agentId, ...data } = payload;

	const response = await apiClient.request({
		method: 'POST',
		endPoint: `${UPDATE_EMBEDDABLE_API_PATH}/${agentId}`,
		body: data,
	});

	return response;
};

export const getEmbeddableConfig = async (embeddableVoiceId: string): Promise<any> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${GET_EMBEDDABLE_API_PATH}/${embeddableVoiceId}`,
	});

	return response;
};
